import { useDispatch } from 'react-redux';
import { GpsIcon, LoaderIcon } from '../../../utils/svg';
import { getCurrentLocation, getDetailLocationFromLatLong, isEmptyData, logError, loggingGps, roundCoordinate } from '../../../utils/helper';
import useGeolocationPermission from '../../../hook/useGeolocationPermission';
import { GEOLOCATION_PERMISSION } from '../../../utils/constants';
import { setUser } from '../../../store/reducers/user';
import { useState } from 'react';
import { setGps } from '../../../store/reducers/gps';

const CurrentLocation = (props) => {
	const { onClose } = props;
	const dispatch = useDispatch();
	const { permission } = useGeolocationPermission();
	const [isLoading, setIsLoading] = useState(false);

	const handleOpenErrorPermission = () => {
		dispatch(
			setGps({
				isShowWarning: true,
			}),
		);
    onClose?.();
	};

	const handleClick = async () => {
		try {
			if (isEmptyData(permission) || permission === GEOLOCATION_PERMISSION.DENIED) return handleOpenErrorPermission();

			setIsLoading(true);
			const loc = await getCurrentLocation();
			const formated = await getDetailLocationFromLatLong(loc.latitude, loc.longitude);
			const address = {
        addressName: null,
				address: formated?.address,
				latitude: formated?.lat,
				longitude: formated?.lng,
				country: formated?.country,
				state: formated?.state,
				city: formated?.city,
				village: formated?.village,
				district: formated?.district,
				postalCode: formated?.postalCode,
				detail: null,
			};
			dispatch(
				setUser({
					...address,
					location_permission: permission,
				}),
			);
      const parsedCoords = {
        latitude: roundCoordinate(loc?.latitude),
        longitude: roundCoordinate(loc?.longitude),
        accuracy: loc?.accuracy,
        altitude: loc?.altitude,
        altitudeAccuracy: loc?.altitudeAccuracy,
        heading: loc?.heading,
        speed: loc?.speed,
      };

			const log = loggingGps({ message: 'Location retrieved successfully' }, parsedCoords);
			dispatch(setGps({ coords: parsedCoords, logs: log }));

			setIsLoading(false);
      onClose?.();
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);

      logError(error, {feature: "CurrentLocation"});
		}
	};

	return (
		<>
			<div onClick={handleClick} className='flex gap-1.5 items-center border-1 border-solid border-gray-300 rounded-full py-1 px-3 bg-gray-50 cursor-pointer'>
				{isLoading ? (
					<LoaderIcon />
				) : (
					<>
						<GpsIcon className={'stroke-yellow-600 w-4'} />
						<div className='text-[var(--dark-gray)] text-xs'>Gunakan Lokasi saat ini</div>
					</>
				)}
			</div>
		</>
	);
};

export default CurrentLocation;
